import { render, staticRenderFns } from "./CompetingInterestsInformation.vue?vue&type=template&id=6619ae22&scoped=true"
import script from "./CompetingInterestsInformation.vue?vue&type=script&lang=js"
export * from "./CompetingInterestsInformation.vue?vue&type=script&lang=js"
import style0 from "./CompetingInterestsInformation.vue?vue&type=style&index=0&id=6619ae22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6619ae22",
  null
  
)

export default component.exports